import { render, staticRenderFns } from "./EditNew.vue?vue&type=template&id=7fc7b4e0&"
import script from "./EditNew.vue?vue&type=script&lang=js&"
export * from "./EditNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports